import React, { useEffect, useState, useCallback } from "react";
import { MyStyledTable } from "../../../style/styleComp";
import moment from "moment";
import "../../../style/customStyles.css";
import { LeftTyre } from "../../../style/truck/LeftTyre";
import { RightTyre } from "../../../style/truck/RightTyre";
import { Circle } from "../../../style/truck/Circle";
import CargoArea from "../../../style/truck/CargoArea";
import Window from "../../../style/truck/Window";
import EngineHeadLight from "../../../style/truck/EngineHeadLight";
import BottomFrame from "../../../style/truck/BottomFrame";
import { trackFeatureAction } from "../../../../../analytics/googleAnalytics";
import { PiSquaresFour } from "react-icons/pi";
import { IoListOutline } from "react-icons/io5";
import {
  Form,
  Input,
  Select,
  Button,
  Pagination,
  notification,
  Space,
  Tag,
  Tooltip,
  Spin
} from "antd";
import { SearchOutlined, FilterOutlined, LoadingOutlined } from "@ant-design/icons";
import { CardContainer } from "../../../style/styleComp";
import { useSelector, useDispatch } from "react-redux";
import { 
  fetchPDDV2,  
  fetchTrackingDetails, 
  clearTrackingDetails 
} from "../../../../../redux/slice/getPDDData";
import { updateBranchEntry } from "../../../../../redux/slice/pddUpdateBranchEntry";
import { fetchPDDAppID } from "../../../../../redux/slice/getPDDAppID"; 
import { HashLoader } from "react-spinners";
import HoInTransitDrawer from "./HoInTransitDrawer";
import AfterReceivedHo from "./HoReceivedDrawer";
import { addMissingDocs } from "../../../../../redux/slice/pddAddMissingDocs";
import { RiRefreshLine } from "react-icons/ri";
import Reports from "../../Reports/Reports";

const { Option } = Select;

const BranchToHO = ({ jwtBearer, extraProp }) => {
  const dispatch = useDispatch();
  
  // Get all data from Redux
  const { 
    v2Loading, 
    v2Data, 
    trackingDetails, 
    trackingLoading, 
    trackingError,
    updateStatusLoading 
  } = useSelector((state) => state.fetchPDD || {});
  
  // Get appID data
  const appIDData = useSelector((state) => state.fetchPDDAppID?.data?.message || []);
  
  // Extract data from API response
  const chatData = v2Data?.data || [];
  const paginationData = v2Data?.pagination || {};
  
  // Local state
  const [searchField, setSearchField] = useState("Select");
  const [searchValue, setSearchValue] = useState("");
  const [tempSearchValue, setTempSearchValue] = useState(""); // Temporary search value
  const [modalVisible, setDetailModalVisible] = useState(false);
  const [detailModalType, setDetailModalType] = useState("inTransit");
  const [selectedTrackingNumber, setSelectedTrackingNumber] = useState("");
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [viewTable, setViewTable] = useState(false);
  const [selectedButton, setSelectedButton] = useState("truckIcon");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [allAppIdData, setAllAppIdData] = useState([]);
  const [cleanAppIDData, setCleanAppIDData] = useState([]);
  const [missingPDDDocs, setMissingPDDDocs] = useState({});

  // Fetch PDD data
  const fetchData = useCallback(async (page = 1, size = 10, searchVal = searchValue, field = searchField) => {
    try {
      const params = {
        page,
        page_size: size
      };

      if (searchVal && field && field !== "Select") {
        if (field === "tracking_number") {
          params.tracking_number = searchVal;
        } else if (field === "application_ids") {
          params.application_id = searchVal;
        }
      }

      await dispatch(fetchPDDV2({ jwtBearer, params }));
      
    } catch (error) {
      console.error("Error fetching data:", error);
      notification.error({
        message: "Fetch Error",
        description: "Failed to fetch data. Please try again.",
      });
    }
  }, [dispatch, jwtBearer, searchValue, searchField]);

  // Fetch App ID data
  const fetchAppIDData = async () => {
    try {
      await dispatch(fetchPDDAppID({ jwtBearer }));
    } catch (error) {
      console.error("Error fetching App ID data:", error);
    }
  };

  // Initialize data
  useEffect(() => {
    fetchData();
    // fetchAppIDData();
  }, []);

  // Update cleanAppIDData when appIDData changes
  useEffect(() => {
    if (appIDData.length > 0 && extraProp?.branch_id) {
      const branchArray = extraProp.branch_id.replace(/[()]/g, "").split(",");
      const cleanData = appIDData.filter((app) =>
        branchArray.includes(app.BR_CD.split(" ")[0])
      );
      setCleanAppIDData(cleanData);
      setAllAppIdData(appIDData);
    }
  }, [appIDData, extraProp]);

  // Handle search button click
  const handleSearch = () => {
    if (tempSearchValue && searchField !== "Select") {
      setSearchValue(tempSearchValue);

      trackFeatureAction("PDD", "From Branch", "search",{ field: searchField });
      fetchData(1, pageSize, tempSearchValue, searchField);
      setCurrentPage(1);
    }
  };

  // Handle reset button click
  const handleReset = () => {
    trackFeatureAction("PDD", "From Branch", "reset");
    setSearchField("Select");
    setTempSearchValue("");
    setSearchValue("");
    fetchData(1, pageSize, "", "Select");
    setCurrentPage(1);
  };

  // Add Enter key handler for the search input
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  // Update table data when v2Data changes
  useEffect(() => {
    if (v2Data && v2Data.success) {
      setTotalItems(paginationData.total_items || 0);
      setTotalPages(paginationData.total_pages || 0);
      setCurrentPage(paginationData.page || 1);
      setPageSize(paginationData.page_size || 10);
    }
  }, [v2Data, paginationData]);

  useEffect(() => {
    if (trackingDetails) {
      const transformedData = transformTrackingData(trackingDetails);
      setSelectedRowData(transformedData);
    }
  }, [trackingDetails]);

  const transformTrackingData = (data) => {
    if (!data) return null;
    
    return {
      ...data,
      application_ids: data.application_ids || [],
      applicant_details: data.applicant_details || {},
      applications: data.applications || [],
      missing_docs: data.missing_docs || {},
      status: data.status,
      branch: data.branch,
      tracking_number: data.tracking_number,
      vendor: data.vendor,
      verification: data.verification,
      courier_dispatcher_name: data.courier_dispatcher_name,
      app_id_status: data.app_id_status
    };
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    fetchData(page, size, searchValue, searchField);
  };

  const handleRefresh = () => {
    trackFeatureAction("PDD", "From Branch", "refresh");
    fetchData(currentPage, pageSize, searchValue, searchField);
  };

  const handleSearchChange = (e) => {
    setTempSearchValue(e.target.value);
  };

  const handleSearchFieldChange = (value) => {
    setSearchField(value);
    if (!value || value === "Select") {
      setTempSearchValue("");
      setSearchValue("");
    }
  };

  const handleCloseModal = () => {
    setDetailModalVisible(false);
    setDetailModalType("inTransit");
    setSelectedTrackingNumber("");
    setSelectedRowData(null);
    setMissingPDDDocs({});
    dispatch(clearTrackingDetails());
  };

  const handleStatusChange = (updatedData) => {
    const requestBody = {
      tracking_number: updatedData.tracking_number,
      app_ids: updatedData.app_id,
      status: updatedData.status,
    };

    dispatch(updateBranchEntry({ jwtBearer, requestBody }))
      .then(() => {
        trackFeatureAction("PDD", "From Branch", "submit", { action_type: "status update" });
        dispatch(fetchPDDV2({ jwtBearer, params: { page: currentPage, page_size: pageSize, tracking_number: searchField === "tracking_number" ? searchValue : undefined, application_id: searchField === "application_ids" ? searchValue : undefined } }));
        setDetailModalVisible(false);
      })
      .catch((error) => {
        console.error("Error updating courier status:", error);
      });
  };

  // Handle missing docs for AfterReceivedHo
  const handleMissingDocs = (updatedData) => {
    const requestBody = {
      branch: updatedData.branch,
      tracking_number: updatedData.tracking_number,
      docs: updatedData.docs,
    };

    dispatch(addMissingDocs({ jwtBearer, requestBody }))
      .then(() => {
        trackFeatureAction("PDD", "From Branch", "submit", { action_type: "missing_documents" });
        fetchData(currentPage, pageSize, searchValue, searchField);
        
        // Refresh tracking details
        dispatch(fetchTrackingDetails({ 
          jwtBearer, 
          tracking_number: selectedTrackingNumber 
        }));
        
        notification.success({
          message: "Documents Added",
          description: "Missing documents have been recorded successfully.",
        });
      })
      .catch((error) => {
        console.error("Error updating courier status:", error);
        notification.error({
          message: "Update Failed",
          description: "Failed to add missing documents.",
        });
      });
  };

  const handleCardClick = async (record) => {
    setSelectedTrackingNumber(record.tracking_number);
    setDetailModalVisible(true);
    trackFeatureAction("PDD", "From Branch", "view");
    
    // Determine which drawer to show based on status
    if (record.status === "3" || record.status === "Received") {
      setDetailModalType("received");
      // For Received status, we need to fetch missing docs
      const requestBody = {
        app_ids: record.application_ids || []
      };
      
      // Note: You might need to adjust this based on your actual API
      // For now, we'll set missing docs from the trackingDetails
      if (record.missing_docs) {
        setMissingPDDDocs(record.missing_docs);
      }
    } else {
      setDetailModalType("inTransit");
    }
    
    try {
      // Dispatch the API call to fetch tracking details
      await dispatch(fetchTrackingDetails({ 
        jwtBearer, 
        tracking_number: record.tracking_number 
      }));
    } catch (error) {
      notification.error({
        message: "Failed to Load Details",
        description: "Could not fetch courier details. Please try again.",
      });
    }
  };

  const handleTableRowClick = async (row) => {
    setSelectedTrackingNumber(row.fullData.tracking_number);
    setDetailModalVisible(true);
    
    // Determine which drawer to show based on status
    if (row.fullData.status === "3" || row.fullData.status === "Received") {
      setDetailModalType("received");
    } else {
      setDetailModalType("inTransit");
    }
    
    try {
      // Dispatch the API call to fetch tracking details
      await dispatch(fetchTrackingDetails({ 
        jwtBearer, 
        tracking_number: row.fullData.tracking_number 
      }));
    } catch (error) {
      notification.error({
        message: "Failed to Load Details",
        description: "Could not fetch courier details. Please try again.",
      });
    }
  };

  // Show error notification if tracking details fetch fails
  useEffect(() => {
    if (trackingError && selectedTrackingNumber) {
      notification.error({
        message: "Failed to Load Details",
        description: trackingError,
        duration: 4.5,
      });
    }
  }, [trackingError, selectedTrackingNumber]);

  const statusCodeToText = (status) => {
    switch (status) {
      case "1":
        return "In-Transit";
      case "2":
        return "In-Query";
      case "3":
        return "Received";
      case "Received":
        return "Received";
      default:
        return "Unknown Status";
    }
  };

  const verificationCodeToText = (verification) => {
    switch (verification) {
      case "4":
        return "Verification Pending";
      case "5":
        return "Verified";
      case "8":
        return "Missing/Damaged Documents";
      default:
        return verification || "Pending";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "1":
        return "#1890ff";
      case "2":
        return "#faad14";
      case "3":
      case "Received":
        return "#52c41a";
      default:
        return "#d9d9d9";
    }
  };

  const getVerificationColor = (verification) => {
    switch (verification) {
      case "4":
        return "#faad14";
      case "5":
        return "#52c41a";
      case "8":
        return "#f5222d";
      default:
        return "#d9d9d9";
    }
  };

  const myColumns = [
    {
      title: "POD Number",
      dataIndex: "tracking_number",
      key: "tracking_number",
      render: (text) => (
        <Tooltip title="Click to view details">
          <span style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}>
            {text || "N/A"}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={getStatusColor(status)} style={{ fontWeight: 500 }}>
          {statusCodeToText(status)}
        </Tag>
      ),
    },
    {
      title: "Verification",
      dataIndex: "verification",
      key: "verification",
      render: (verification) => (
        <Tag color={getVerificationColor(verification)} style={{ fontWeight: 500 }}>
          {verificationCodeToText(verification)}
        </Tag>
      ),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      render: (text) => text || "N/A",
    },
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text) => text || "N/A",
    },
    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (
        <Tooltip title={moment(text).format("DD-MM-YYYY HH:mm")}>
          <span>{moment(text).format("DD-MM-YYYY")}</span>
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button 
          type="link" 
          onClick={() => handleTableRowClick(record)}
          style={{ padding: 0 }}
          loading={trackingLoading && selectedTrackingNumber === record.tracking_number}
        >
          {trackingLoading && selectedTrackingNumber === record.tracking_number ? (
            <LoadingOutlined />
          ) : (
            "View Details"
          )}
        </Button>
      ),
    },
  ];

  const myFormattedData = chatData.map((item) => ({
    ...item,
    fullData: item,
    key: item.tracking_number || Math.random().toString(),
  }));

  return (
    <>
      {/* Header Section */}
      <div style={{ 
        padding: "20px", 
        backgroundColor: "#fff", 
        borderRadius: "12px", 
        marginBottom: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
      }}>
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          flexWrap: "wrap",
          gap: "20px"
        }}>
          {/* Search Section */}
          <Space size="large" style={{ flex: 1, minWidth: "300px" }}>
            <Form layout="inline" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Form.Item style={{ margin: 0 }}>
                <Select
                  value={searchField}
                  onChange={handleSearchFieldChange}
                  style={{
                    width: 170,
                    height: 49,
                    borderRadius: "5px",
                    border: "1px solid #d9d9d9",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    fontSize: "16px",
                  }}
                  placeholder="Search by"
                  suffixIcon={<FilterOutlined />}
                >
                  <Option value="Select" disabled>Select Field</Option>
                  <Option value="tracking_number">POD Number</Option>
                  <Option value="application_ids">Application ID</Option>
                </Select>
              </Form.Item>

              <Form.Item style={{ margin: 0, flex: 1 }}>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Input
                    placeholder="Search..."
                    value={tempSearchValue}
                    onChange={handleSearchChange}
                    onKeyPress={handleKeyPress}
                    prefix={<SearchOutlined style={{ color: "#1890ff", marginRight: "10px" }} />}
                    disabled={searchField === "Select"}
                    style={{
                      height: 49,
                      width: 250,
                      borderRadius: "5px",
                      border: "1px solid #d9d9d9",
                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                      fontSize: "16px",
                    }}
                  />
                  <Button
                    type="primary"
                    onClick={handleSearch}
                    disabled={!tempSearchValue || searchField === "Select"}
                    style={{
                      height: 49,
                      minWidth: 80,
                      borderRadius: "5px",
                      fontSize: "15px",
                      fontWeight: 500,
                      background: !tempSearchValue || searchField === "Select" ? "#f5f5f5" : "#1890ff",
                      borderColor: !tempSearchValue || searchField === "Select" ? "#d9d9d9" : "#1890ff",
                      color: !tempSearchValue || searchField === "Select" ? "#bfbfbf" : "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                    }}
                  >
                    <SearchOutlined /> Search
                  </Button>
                  <Button
                    onClick={handleReset}
                    style={{
                      height: 49,
                      minWidth: 80,
                      borderRadius: "5px",
                      fontSize: "15px",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      border: "1px solid #d9d9d9",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </Space>

          {/* View Toggle and Refresh */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "16px"
          }}>
            {/* View Toggle Buttons */}
            <div
              style={{
                display: "flex",
                gap: "5px",
                borderRadius: "10px",
                background: "#f8fafc",
                padding: "4px",
                border: "1px solid #e2e8f0"
              }}
            >
              <div>
                <Button
                  type="primary"
                  shape="circle"
                  size="large"
                  onClick={handleRefresh}
                  style={{
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "white",
                    position: "relative",
                    padding: 0,
                    borderRadius: "50%",
                  }}
                >
                  {v2Loading ? (
                    <span
                      className={v2Loading ? "spin" : ""}
                      style={{
                        fontSize: "16px",
                        fontWeight: "900",
                        color: "blue",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                        transformOrigin: "50% 50%",
                      }}
                    >
                      <RiRefreshLine
                        style={{
                          fontSize: "40px",
                          color: "blue",
                          marginLeft: "4px",
                        }}
                        className="spin"
                      />
                    </span>
                  ) : (
                    <RiRefreshLine
                      style={{
                        fontSize: "40px",
                        color: "blue",
                        marginLeft: "4px",
                      }}
                    />
                  )}
                </Button>
              </div>
              <button
                onClick={() => {
                  setViewTable(false);
                  setSelectedButton("truckIcon");
                }}
                style={{
                  background: selectedButton === "truckIcon" ? "#ffffff" : "transparent",
                  border: selectedButton === "truckIcon" ? "1px solid #e2e8f0" : "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  paddingTop: "8px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                  borderRadius: "8px",
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  boxShadow: selectedButton === "truckIcon" 
                    ? "0 2px 8px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)" 
                    : "none",
                  color: selectedButton === "truckIcon" ? "#1890ff" : "#64748b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none"
                }}
                onMouseEnter={(e) => {
                  if (selectedButton !== "truckIcon") {
                    e.currentTarget.style.background = "#f1f5f9";
                    e.currentTarget.style.color = "#334155";
                  }
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  if (selectedButton !== "truckIcon") {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "#64748b";
                  }
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <PiSquaresFour />
              </button>
              
              <button
                onClick={() => {
                  setViewTable(true);
                  setSelectedButton("table");
                }}
                style={{
                  background: selectedButton === "table" ? "#ffffff" : "transparent",
                  border: selectedButton === "table" ? "1px solid #e2e8f0" : "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  paddingTop: "8px",
                  paddingBottom: "4px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                  borderRadius: "8px",
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  boxShadow: selectedButton === "table" 
                    ? "0 2px 8px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)" 
                    : "none",
                  color: selectedButton === "table" ? "#1890ff" : "#64748b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none"
                }}
                onMouseEnter={(e) => {
                  if (selectedButton !== "table") {
                    e.currentTarget.style.background = "#f1f5f9";
                    e.currentTarget.style.color = "#334155";
                  }
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  if (selectedButton !== "table") {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "#64748b";
                  }
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <IoListOutline />
              </button>
            </div>

            {/* Reports Component */}
            <Reports jwtBearer={jwtBearer} />
          </div>
        </div>
      </div>

      {/* Content Section */}
      {v2Loading ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(100vh - 200px)",
          width: "100%",
          background: "#fff",
          borderRadius: "12px",
          padding: "20px"
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
            maxWidth: "400px",
            width: "100%"
          }}>
            <HashLoader 
              color="#1890ff" 
              size={55} 
            />
            
            <div style={{ 
              marginTop: "24px",
              textAlign: "center"
            }}>
              <div style={{ 
                color: "#1e293b", 
                fontSize: "18px", 
                fontWeight: "600",
                marginBottom: "8px"
              }}>
                Loading PDD data
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {viewTable ? (
            /* Table View */
            <div style={{ 
              padding: "20px", 
              backgroundColor: "#fff", 
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
            }}>
              <div style={{ 
                display: "flex", 
                justifyContent: "space-between", 
                alignItems: "center",
                marginBottom: "20px",
                paddingBottom: "15px",
                borderBottom: "1px solid #f0f0f0"
              }}>
                <div>
                  <h3 style={{ margin: 0, color: "#262626" }}>Courier Management</h3>
                  <div style={{ color: "#8c8c8c", fontSize: "14px", marginTop: "4px" }}>
                    Total: <strong style={{ color: "#1890ff" }}>{totalItems}</strong> couriers
                  </div>
                </div>
                <div style={{ color: "#666", fontSize: "14px" }}>
                  Showing {(currentPage - 1) * pageSize + 1} to {Math.min(currentPage * pageSize, totalItems)} of {totalItems} entries
                </div>
              </div>

              <MyStyledTable
                columns={myColumns}
                dataSource={myFormattedData}
                rowKey="key"
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  total: totalItems,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "30", "50", "100"],
                  onChange: handlePageChange,
                  onShowSizeChange: handlePageChange,
                  showTotal: (total, range) => (
                    <div style={{ padding: "8px 0", color: "#666" }}>
                      Showing {range[0]}-{range[1]} of {total} items
                    </div>
                  ),
                  style: { marginTop: "20px" }
                }}
                onRow={(record) => ({
                  onClick: () => handleTableRowClick(record),
                  style: { 
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#fafafa'
                    }
                  }
                })}
              />
            </div>
          ) : (
            /* Card View */
            <div style={{ 
              padding: "20px", 
              backgroundColor: "#fff", 
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
            }}>
              {myFormattedData.length === 0 ? (
                <div style={{ 
                  textAlign: "center", 
                  padding: "80px 20px", 
                  color: "#8c8c8c",
                  backgroundColor: "#fafafa",
                  borderRadius: "8px",
                  border: "1px dashed #d9d9d9"
                }}>
                  <SearchOutlined style={{ fontSize: "48px", color: "#bfbfbf", marginBottom: "16px" }} />
                  <div style={{ fontSize: "16px", marginBottom: "8px" }}>No couriers found</div>
                  <div style={{ fontSize: "14px", color: "#8c8c8c" }}>
                    {searchValue ? "Try a different search term" : "No data available"}
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ 
                    display: "grid", 
                    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", 
                    gap: "20px",
                    marginBottom: "30px"
                  }}>
                    {myFormattedData.map((data, index) => (
                      <div
                        key={data.tracking_number || index}
                        style={{
                          // border: `2px solid ${getStatusColor(data.status)}`,
                          // borderRadius: "12px",
                          // padding: "16px",
                          // backgroundColor: "#fff",
                          // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          position: "relative",
                          overflow: "hidden",
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                          }
                        }}
                        onClick={() => handleCardClick(data)}
                      >
                        {/* Loading overlay for specific card */}
                        {trackingLoading && selectedTrackingNumber === data.tracking_number && (
                          <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10,
                            borderRadius: "12px"
                          }}>
                            <Spin size="small" />
                          </div>
                        )}

                        {/* Truck Visualization */}
                        <div style={{ marginTop: "30px", textAlign: "center",marginLeft:"10px" }}>
                          <div style={{ display: "flex", marginTop: "15px" }}>
                            <div
                              style={{
                                width: "150px",
                                height: "60px",
                                border: "2px solid black",
                                backgroundColor: "transparent",
                                borderRadius: "10px 10px 0 0",
                              }}
                            >
                              <CargoArea data={data} />
                            </div>
                            <Window data={data} />
                            <div style={{ alignSelf: "flex-end" }}>
                              <EngineHeadLight data={data} />
                            </div>
                          </div>
                          <div style={{ position: "relative" }}>
                            <BottomFrame data={data} />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                position: "absolute",
                                top: "0",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: "180px",
                                  top: "2.5px",
                                }}
                              >
                                <Circle />
                              </div>
                              <div
                                style={{
                                  position: "absolute",
                                  left: "35px",
                                  top: "2.5px",
                                }}
                              >
                                <Circle />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <LeftTyre />
                                </div>
                                <div>
                                  <RightTyre />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Information Section */}
                        <div style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #f0f0f0" }}>
                          {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span style={{ color: "#666", fontSize: "14px" }}>POD Number:</span>
                            <span style={{ fontWeight: "500", fontSize: "14px" }}>{data.tracking_number}</span>
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span style={{ color: "#666", fontSize: "14px" }}>Status:</span>
                            <Tag color={getStatusColor(data.status)} style={{ fontWeight: 500, margin: 0 }}>
                              {statusCodeToText(data.status)}
                            </Tag>
                          </div> */}
                          {/* <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span style={{ color: "#666", fontSize: "14px" }}>Branch:</span>
                            <span style={{ fontWeight: "500", fontSize: "14px" }}>{data.branch || "N/A"}</span>
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ color: "#666", fontSize: "14px" }}>Created:</span>
                            <span style={{ fontSize: "14px" }}>{moment(data.created_at).format("DD-MM-YYYY")}</span>
                          </div> */}
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Pagination */}
                  <div style={{ 
                    marginTop: "40px",
                    padding: "24px",
                    backgroundColor: "#fafafa",
                    borderRadius: "12px",
                    border: "1px solid #f0f0f0"
                  }}>
                    <div style={{ 
                      display: "flex", 
                      justifyContent: "space-between", 
                      alignItems: "center",
                      marginBottom: "20px"
                    }}>
                      <div style={{ fontSize: "14px", color: "#666" }}>
                        Showing <strong style={{ color: "#1890ff" }}>{myFormattedData.length}</strong> of <strong style={{ color: "#1890ff" }}>{totalItems}</strong> couriers
                      </div>
                      <div style={{ fontSize: "14px", color: "#666" }}>
                        Page <strong style={{ color: "#1890ff" }}>{currentPage}</strong> of <strong style={{ color: "#1890ff" }}>{totalPages}</strong>
                      </div>
                    </div>
                    
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={totalItems}
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={["10", "20", "30", "50", "100"]}
                        onChange={handlePageChange}
                        onShowSizeChange={handlePageChange}
                        style={{ margin: 0 }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </>
      )}

      {/* HoDetailDrawer (HoInTransitDrawer) for In-Transit/In-Query status */}
      {detailModalType === "inTransit" && (
        <HoInTransitDrawer
          visible={modalVisible}
          onClose={handleCloseModal}
          data={selectedRowData}
          onStatusChange={handleStatusChange}
          drawerLoading={trackingLoading || updateStatusLoading}
        />
      )}

      {/* AfterReceivedHo for Received status */}
      {detailModalType === "received" && selectedRowData && (
        <AfterReceivedHo
          visible={modalVisible}
          onClose={handleCloseModal}
          data={selectedRowData}
          onMissingDocs={handleMissingDocs}
          all_app_id={allAppIdData} 
          missing_docs={selectedRowData?.missing_docs || {}}
          statusDetails={extraProp?.statusDetails || {}}
          myLoading={trackingLoading}
          app_id={cleanAppIDData} 
          branchId={selectedRowData?.branch?.split("-")[0]?.trim()}
        />
      )}
    </>
  );
};

export default BranchToHO;